import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ErrorState } from "@/components/ErrorState";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname || "/dashboard", { replace: true, state: { user: data } });
      })
      .catch((err) => setError(errorMessage(err)));
  }, [location, navigate, setUser]);

  if (error) return <ErrorState status={403} title="Sign-in failed" text={error} />;
  return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500" data-testid="auth-callback">Signing you in…</div>;
}
